// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BlogsPopularFeed":"it_a bag_ob bag_a bag_w","BlogsPopularFeed__loading":"it_b"};